// extracted by mini-css-extract-plugin
export default {"browseContainer":"_3dOnM82R","browseCTA":"u8_uHwiH","browseCta":"u8_uHwiH","browseCopy":"T-Is6h9U"};